/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1QueueDetails } from '../models/V1QueueDetails';
import { HttpFile } from '../http/http';

/**
* Info about all the queues in the target system. Right now, only the main queue details are being returned.
*/
export class V1QueueHealth {
    'queueDetails'?: Array<V1QueueDetails>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "queueDetails",
            "baseName": "queue_details",
            "type": "Array<V1QueueDetails>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1QueueHealth.attributeTypeMap;
    }

    public constructor() {
    }
}

